import {
    type MassManagementActionType,
    FINISH_MASS_MANAGEMENT_FETCH,
    START_MASS_MANAGEMENT_FETCH,
} from "../actions/MassManagementActions";

export type MassManagementStateType = {
    loading: boolean;
    loaded: boolean;
    error: boolean;
    exceedingKilogram: number;
};

export const initialState: MassManagementStateType = {
    loading: false,
    loaded: false,
    error: false,
    exceedingKilogram: 0,
};

const MassManagementReducer = (
    state: MassManagementStateType = initialState,
    action: MassManagementActionType,
): MassManagementStateType => {
    switch (action.type) {
        // If external price is being loaded, it will automatically retrieve the mass management information
        case START_MASS_MANAGEMENT_FETCH:
            return { ...state, loading: true };

        case FINISH_MASS_MANAGEMENT_FETCH:
            return {
                ...state,
                loading: false,
                loaded: true,
                exceedingKilogram: action.exceedingKilogram,
                error: action.isError,
            };

        default:
            return state;
    }
};
export default MassManagementReducer;
